var map = {
	"./120694.jpg": 5062,
	"./DinfinityAcademyAbout_1018.png": 6192,
	"./SDGs/SDGs01.svg": 9066,
	"./SDGs/SDGs02.svg": 7186,
	"./SDGs/SDGs03.svg": 420,
	"./SDGs/SDGs04.svg": 2532,
	"./SDGs/SDGs05.svg": 1590,
	"./SDGs/SDGs06.svg": 3793,
	"./SDGs/SDGs07.svg": 8643,
	"./SDGs/SDGs08.svg": 5910,
	"./SDGs/SDGs09.svg": 4779,
	"./SDGs/SDGs10.svg": 9315,
	"./SDGs/SDGs11.svg": 1561,
	"./SDGs/SDGs12.svg": 7253,
	"./SDGs/SDGs13.svg": 6966,
	"./SDGs/SDGs14.svg": 6981,
	"./SDGs/SDGs15.svg": 5988,
	"./SDGs/SDGs16.svg": 658,
	"./SDGs/SDGs17.svg": 1540,
	"./banner/20210408162604.jpg": 41,
	"./banner/386049947_2708981682608890_7614944733634222441_n.jpg": 2575,
	"./banner/75.jpg": 8608,
	"./banner/CIMG1764.jpg": 9714,
	"./banner/DSC00162.jpg": 795,
	"./banner/DSC00164.jpg": 4981,
	"./banner/DSC00420.jpg": 5246,
	"./banner/S__31244291.jpg": 5485,
	"./banner/S__31244293_0.jpg": 7595,
	"./banner/S__31244294_0.jpg": 8346,
	"./banner/S__35479582.jpg": 6125,
	"./banner/for2.jpg": 1919,
	"./certificate/certificate01.jpg": 6102,
	"./certificate/certificate02.jpg": 5414,
	"./doNotTouch/BG-infinityb.svg": 201,
	"./doNotTouch/accessibility_AA_logo.png": 9182,
	"./doNotTouch/d-infinite_logo_white.png": 6904,
	"./doNotTouch/indexBg_standard_down.svg": 2817,
	"./doNotTouch/indexBg_standard_up.svg": 6793,
	"./doNotTouch/indexBg_standard_up2.svg": 3412,
	"./doNotTouch/minLogo.png": 4441,
	"./doNotTouch/pcNav_up.svg": 6666,
	"./howToGetPoints.png": 2550,
	"./icon/FB01.svg": 457,
	"./icon/Twitter01.svg": 8734,
	"./icon/line01.svg": 1728,
	"./index/index-STEAM.png": 7242,
	"./index/index-communicate.png": 4775,
	"./index/index-digital.png": 7272,
	"./learning/1121/1121001.jpg": 7644,
	"./learning/1121/1121002.jpg": 2439,
	"./learning/process.jpg": 2324,
	"./members/1000-1.jpg": 4166,
	"./members/120694.jpg": 3912,
	"./members/1390.jpg": 9639,
	"./members/1436.jpg": 2090,
	"./members/1450.jpg": 6866,
	"./members/1475-1.jpg": 8620,
	"./members/1476-1.jpg": 5667,
	"./members/1644.jpg": 7587,
	"./members/1832-3.jpg": 5522,
	"./members/2000.jpg": 3580,
	"./members/2011-1.jpg": 3107,
	"./members/2015-1.jpg": 7046,
	"./members/2350.jpg": 1822,
	"./members/2370-1.jpg": 289,
	"./members/2404.jpg": 8927,
	"./members/2405-1.jpg": 740,
	"./members/2427-2.jpg": 8960,
	"./members/3000.jpg": 834,
	"./members/3133-1.jpg": 9544,
	"./members/5250.jpg": 3550,
	"./members/6003.jpg": 6344,
	"./members/6200-1.jpg": 78,
	"./members/7000.jpg": 6136,
	"./members/KuoKengYuan_0.png": 8990,
	"./members/LinChienYu_0.jpg": 4963,
	"./members/P2228.jpeg": 312,
	"./members/T0058.jpg": 405,
	"./members/T0363-1.png": 3923,
	"./members/T0604.jpg": 4361,
	"./members/T0793.jpg": 9299,
	"./members/T0860.jpg": 4242,
	"./members/jing.jpg": 7674,
	"./members/newhill05.jpg": 3609,
	"./organizationalChart.png": 2267,
	"./portfolio/1121/STEAM01.png": 7613,
	"./portfolio/1121/STEAM02.jpg": 2337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6672;